<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
              >保存</el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            class="eidt-el-form el-form-wrap"
          >
            <div class="line-box">
              <el-form-item label="名称" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="banner图片">
                <UploadImg
                  @uploadImg="getUploadImg"
                  :editImg="editImg"
                ></UploadImg>
              </el-form-item>
              <el-form-item label="规则图片" prop="rule">
                <UploadImg
                  @uploadImg="getUploadImg2"
                  :editImg="editImg2"
                ></UploadImg>
              </el-form-item>
              <el-form-item label="微信分享描述" prop="description">
                <el-input
                  v-model="ruleForm.description"
                  :autosize="{ minRows: 4, maxRows: 1000 }"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <UploadImg
                  @uploadImg="getUploadImg4"
                  :editImg="editImg4"
                  :imgTitle="imgTitle4"
                ></UploadImg>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="抽奖类型" prop="type">
                <el-select
                  placeholder="抽奖类型："
                  clearable
                  @change="getChageType"
                  v-model="ruleForm.type"
                  class="el-input-position"
                >
                  <el-option
                    v-for="(item, index) in types"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间" prop="startDate">
                <el-date-picker
                  v-model="ruleForm.startDate"
                  type="datetime"
                  placeholder="开始时间"
                ></el-date-picker
              ></el-form-item>
              <el-form-item label="结束时间" prop="endDate">
                <el-date-picker
                  v-model="ruleForm.endDate"
                  type="datetime"
                  placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="抽奖状态：">
                <el-radio-group
                  v-model="ruleForm.enabled"
                  @change="getChageRadio"
                >
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="checkIn" label="最大抽奖次数">
                <el-input
                  v-model="ruleForm.checkIn"
                  style="width: 65px"
                  type="number"
                  min="1"
                  minlength="1"
                  maxlength="2"
                  max="6"
                  class="el-input"
                ></el-input>
              </el-form-item>
              <el-form-item label="分享抽奖次数" prop="total">
                <el-input
                  v-model="ruleForm.total"
                  style="width: 65px"
                  type="number"
                  min="1"
                  minlength="1"
                  maxlength="2"
                  max="6"
                  class="el-input"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <el-divider content-position="left">抽奖奖品</el-divider>
        <el-form
          ref="tableData"
          :model="list"
          :rules="rules1"
          class="demo-ruleForm"
        >
          <el-button
            style="float: right; margin-left: 10px"
            type="primary"
            @click="save"
            >保存奖品</el-button
          >
          <el-button
            style="float: right; margin-left: 10px"
            type="primary"
            plain
            @click="addRow"
            >新增奖品</el-button
          >
          <el-table
            :data="list.tableData"
            style="width: 100%; margin-bottom: 30px; z-index: 1"
          >
            <el-table-column width="100" label="排序">
              <template slot-scope="scope" prop="indexNo">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.indexNo'"
                  :rules="rules1.indexNo"
                >
                  <el-input
                    v-model="scope.row.indexNo"
                    style="width: 65px"
                    type="number"
                    min="1"
                    minlength="1"
                    maxlength="2"
                    @change="indexChange()"
                    max="99"
                    class="el-input"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="启用" width="150">
              <template slot-scope="scope" prop="enabled">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.enabled'"
                  :rules="rules1.enabled"
                >
                  <el-radio-group v-model="scope.row.enabled">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="名称" width="250">
              <template slot-scope="scope" prop="name">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.name'"
                  :rules="rules1.name"
                >
                  <el-input
                    v-model="scope.row.name"
                    clearable
                    placeholder="奖品名称"
                    class="el-input-position"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="中奖规则" width="150">
              <template slot-scope="scope" prop="rule">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.rule'"
                  :rules="rules1.name"
                >
                  <el-input
                    v-model="scope.row.rule"
                    clearable
                    placeholder="中奖规则"
                    class="el-input-position"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="150">
              <template slot-scope="scope" prop="remark">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.remark'"
                  :rules="rules1.remark"
                >
                  <el-input
                    v-model="scope.row.remark"
                    clearable
                    class="el-input-position"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="已中奖人数" width="100">
              <template slot-scope="scope" prop="remark">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.checkIn'"
                  :rules="rules1.checkIn"
                >
                  <el-input
                    v-model="scope.row.checkIn"
                    style="width: 65px"
                    type="number"
                    min="0"
                    max="999999"
                    class="el-input"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="最大人数" width="100">
              <template slot-scope="scope" prop="input">
                <el-form-item
                  :prop="'tableData.' + scope.$index + '.total'"
                  :rules="rules1.total"
                >
                  <el-input
                    v-model="scope.row.total"
                    style="width: 65px"
                    type="number"
                    min="0"
                    max="999999"
                    class="el-input"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="奖品图片">
              <template slot-scope="scope" prop="options">
                <el-form-item>
                  <el-form-item>
                    <UploadImg
                      @uploadImg="getUploadImg1(scope.$index)"
                      :editImg="scope.row.url"
                    ></UploadImg>
                  </el-form-item>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="60" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  plain
                  @click="deleterow(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
            <el-table-column width="10"></el-table-column>
          </el-table>
        </el-form>
      </el-row>
    </div>
  </div>
</template>
<script>
function sortBy(props) {
  return function (a, b) {
    return a[props] - b[props];
  };
}
function filterOne(dataList, value, type) {
  var s = dataList.filter(function (item, index, arr) {
    for (let j = 0; j < type.length; j++) {
      if (item[type[j]] != undefined || item[type[j]] != null) {
        if (item[type[j]].indexOf(value) >= 0) {
          return item;
        }
      }
    }
  });
  return s;
}

var types = [{ name: "中秋博饼", value: "1" }];

import UploadImg from "../public/UploadImg";

export default {
  name: "editvihicel",
  data() {
    return {
      rules: {
        englishName: [
          { required: false, message: "名称不能为空", trigger: "blur" },
        ],
        type: [{ required: true, message: "类型不能为空", trigger: "blur" }],
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        banner: [{ required: false, message: "头部不能为空", trigger: "blur" }],
        bannerMobile: [
          { required: false, message: "头部不能为空", trigger: "blur" },
        ],
        documentTypeId: [
          { required: true, message: "证件类型不能为空", trigger: "blur" },
        ],
      },
      rules1: {
        checkIn: [
          { required: false, message: "已中奖人数不能为空", trigger: "blur" },
        ],
        total: [
          { required: false, message: "最大中奖人数不能为空", trigger: "blur" },
        ],
        name: [{ required: false, message: "名称不能为空", trigger: "blur" }],
        indexNo: [{ required: true, message: "排序不能为空", trigger: "blur" }],
      },
      types: types,
      projectId: localStorage.getItem("project_Id"),
      ruleForm: {
        name: "",
        url: "",
        rule: "",
        startDate: "",
        endDate: "",
        banner: "",
        enabled: 0,
        total: 0,
        checkIn: 0,
        type: "1",
        projectId: localStorage.getItem("project_Id"),
        img: "",
        description: "",
      },
      raffle_Id: "",
      editImg: "",
      editImg2: "",
      editImg4: "",
      imgTitle: "上传图片",
      imgTitle1: "上传图片",
      imgTitle2: "上传图片",
      imgTitle4: "微信分享图片",
      list: {
        tableData: [
          {
            indexNo: 1,
            raffleItemId: 0,
            name: "",
            url: "",
            remark: "",
            enabled: 1,
            rule: "",
            total: 0,
            checkIn: 0,
            projectId: localStorage.getItem("project_Id"),
            type: "1",
          },
        ],
      },
    };
  },
  created() {},
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      if (this.editData) {
        this.ruleForm = this.editData;
        this.ruleForm.type = this.editData.type.toString();
        this.raffle_Id = this.editData.raffleId;
        this.editImg = this.editData.banner;
        this.editImg2 = this.editData.rule;
        this.editImg4 = this.editData.img;
        this.$axios.get("/RaffleItem/all/" + this.raffle_Id).then((res) => {
          if (res.data.hasError == false) {
            this.list.tableData = [...res.data.data];
          }
        });
      }
    },
  },
  methods: {
    handleSelect(item, filed) {
      this.list.tableData[filed].name = item.name;
      this.list.tableData[filed].englishName = item.value;
      this.list.tableData[filed].type = item.type;
    },
    querySearch(queryString, cb) {
      cb(filterOne(array, queryString, ["value"]));
    },
    save() {
      this.$refs.tableData.validate((valid) => {
        var list = new Array();
        var list1 = new Array();
        for (var i = 0; i < this.list.tableData.length; i++) {
          if (
            this.list.tableData[i].name != null &&
            this.list.tableData[i].name != ""
          ) {
            if (list.includes(this.list.tableData[i].name)) {
              this.$message.error(
                this.list.tableData[i].name + ",不能重复使用"
              );
              valid = false;
              break;
            }
            list.push(this.list.tableData[i].name);
          }
        }
        if (valid) {
          if (this.raffle_Id == "" || this.raffle_Id == undefined) {
            this.$message.error("请先保存抽奖信息");
          } else if (
            this.list.tableData == null ||
            this.list.tableData.length == 0
          ) {
            this.$message.error("请添加奖品");
          } else {
            this.list.tableData.forEach((e) => {
              e.raffleId = this.raffle_Id;
            });

            this.$axios
              .post("/RaffleItem/", this.list.tableData)
              .then((res) => {
                if (res.data.hasError == false) {
                  this.$message.success("编辑成功！");
                  this.goBack();
                } else {

                  this.$message.error(res.data.message);
                }
              });
          }
        }
      });
    },
    saveClick(ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var s = new Date(this.ruleForm.startDate);
          var state_date =
            s.getFullYear() +
            "-" +
            (s.getMonth() + 1) +
            "-" +
            (s.getDate() < 10 ? "0" + s.getDate() : s.getDate()) +
            " " +
            s.getHours() +
            ":" +
            s.getMinutes() +
            ":" +
            s.getSeconds();

          var e = new Date(this.ruleForm.endDate);
          var end_date =
            e.getFullYear() +
            "-" +
            (e.getMonth() + 1) +
            "-" +
            (e.getDate() < 10 ? "0" + e.getDate() : e.getDate()) +
            " " +
            e.getHours() +
            ":" +
            e.getMinutes() +
            ":" +
            e.getSeconds();
          this.ruleForm.startDate = state_date;
          this.ruleForm.endDate = end_date;
          if (this.raffle_Id == "" || this.raffle_Id == undefined) {
            this.$axios.post("/Raffle/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.raffle_Id = res.data.data.raffleId;
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
              .put("/Raffle/" + this.raffle_Id + "", this.ruleForm)
              .then((res) => {
                if (res.data.hasError == false) {
                  this.$message.success("编辑成功！");
                  this.goBack();
                } else {

                  this.$message.error(res.data.message);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    indexChange() {
      this.list.tableData.sort(sortBy("indexNo"));
    },
    addRow() {
      var list = {
        indexNo: this.list.tableData.length + 1,
        raffleItemId: 0,
        name: "",
        url: "",
        remark: "",
        enabled: 1,
        rule: "",
        total: 0,
        checkIn: 0,
        projectId: localStorage.getItem("project_Id"),
        type: this.ruleForm.type,
      };
      this.list.tableData.push(list);
    },
    deleterow(index, row) {
      this.list.tableData.splice(index, 1);
      for (var i = 0; i < this.list.tableData.length; i++) {
        this.list.tableData[index].indexNo = i + 1;
      }
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.raffle_Id = "";
      this.$refs.ruleForm.resetFields();
      this.editImg = "";
      this.editImg1 = "";
      this.list.tableData = [];
    },
    selectChange(val) {},
    getChageRadio(value) {
      this.ruleForm.enabled = value;
    },
    getChageType(val) {
      this.ruleForm.lang = this.types[val - 1].name;
    },
    getWechatRadio(value) {
      this.ruleForm.wechat = value;
    },
    getVerifyRadio(value) {
      this.ruleForm.verify = value;
    },
    getEnglishRadio(value) {
      this.ruleForm.english = value;
      if (value == 1) {
        rules.englishName.required = true;
        rules1.englishName.required = true;
        //rules1.englishOption.required=true;
      } else {
        rules.englishName.required = false;
        rules1.englishName.required = false;
        //rules1.englishOption.required=false;
      }
    },
    getUploadImg(imgSrc) {
      this.ruleForm.banner = imgSrc;
    },
    getUploadImg1(imgSrc, i) {
      this.list.tableData[i].url = imgSrc;
    },
    getUploadImg2(imgSrc) {
      this.ruleForm.rule = imgSrc;
    },
    getUploadImg4(imgSrc) {
      this.ruleForm.img = imgSrc;
    },
  },
  components: {
    UploadImg,
  },
};
</script>

<style lang="scss" scoped>
.el-form-wrap {
  width: 100% !important;
}
.line-box {
  display: flex;
  flex: 1;
}
.line-box .el-form-item,
.line-box .up-img {
  width: 40% !important;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>